import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  EventReqDtos,
  HospitalCenterReqDto,
  LeadRespDto,
  LeadsDto,
} from "../../../api/interfaces/LeadsDto";
import {
  getBookStatus,
  getDotColor,
  getEventTypes,
  getStatusClass,
  getStatusDisplayName,
} from "../../../utility/RolesUtility";
import { getService } from "../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../api";
import { useLoader } from "../../../Loader/LoaderContext";
import ReadMore from "../leads/ReadMore";

// Define the type for the section names
type SectionName =
  | "bannerAds"
  | "emailMarketing"
  | "contentMarketing"
  | "printAdvertisement"
  | "additionalService"
  | "eNewsLetter"
  | "isEventListing";
const getSource: Record<string, string> = {
  INTERNAL: "Internal",
  REFRAL: "Refral",
  INBOUND_CALL: "Inbound Call",
  INT_PROMOTIONS: "Int Promotions",
  SOCIAL_MEDIA: "Social Media",
  WEBSITE: "Website",
};
const Booking = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<LeadsDto>();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("bookingid");
  const nameOfBooking = searchParams.get("nameOfBooking");
  const { setLoading } = useLoader();
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const [submittedData, setSubmittedData] = useState<LeadsDto | null>(null);
  // State to track the open/closed status of each section with explicit typing
  const [openSections, setOpenSections] = useState<{
    [key in SectionName]: boolean;
  }>({
    bannerAds: false,
    emailMarketing: false,
    contentMarketing: false,
    printAdvertisement: false,
    additionalService: false,
    eNewsLetter: false,
    isEventListing: false,
  });

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    setLoading(true);
    try {
      let url: any;
      // if(path === '/portals/leads/ViewDetails'){

      if (userInfo.roles === "SALES_MANAGER") {
        url = API_ENDPOINTS.editSalesManagerProposalBooking;
      } else if (userInfo.roles === "SALES_ADMIN") {
        url = API_ENDPOINTS.editSalesAdminProposalBooking;
      } else if (userInfo.roles === "SALES_TEAM_LEAD") {
        url = API_ENDPOINTS.editSalesTlProposalBooking;
      } else if (userInfo.roles === "SALES_EXECUTIVE") {
        url = API_ENDPOINTS.editSalesExecutiveProposalBooking;
      }
      const response = await getService(url + "?bookingId=" + userId);
      setData(response.data);
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (error) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
      console.error("Error fetching vehicle data:", error);
    } finally {
    }
  };

  const users = () => {
    navigate("/portals/bookings/viewBooking");
  };

  //   const editProfile=(data:any) =>{

  //     navigate('/portals/bookings/addBooking?leadId='+data?.id)
  //  }

  const getleadType: Record<string, string> = {
    COMPANY: "Company Name",
    EVENT_ORGANIZER: "Event Organiser Name",
    HOSPITAL: "Hospital Name",
  };
  const leadTypeMapping: Record<string, string> = {
    COMPANY: "Company",
    EVENT_ORGANIZER: "Event Organiser",
    HOSPITAL: "Hospital",
  };
  const leadTypeMappings: Record<string, string> = {
    COMPANY: "Company Details",
    EVENT_ORGANIZER: "Event Organiser Details",
    HOSPITAL: "Hospital Details",
  };
  const getCenterSize: Record<string, string> = {
    SMALL: "Small",
    MEDIUM: "Medium",
    LARGE: "Large",
  };

  const editProfile = (data: any) => {
    if (data?.id) {
      navigate("/portals/bookings/addBooking?bookingId=" + data?.id);
    } else {
      console.warn("Data ID is undefined");
    }
  };

  const editProposal = (data: any) => {
    if (data?.id) {
      if (nameOfBooking === "viewBooking") {
        navigate(
          `/portals/bookings/viewBooking/addProposal?appUserId=${
            data?.id
          }&companyName=${encodeURIComponent(
            data?.companyName
          )}&screen=viewBooked`
        );
      } else {
        navigate(
          `/portals/bookings/viewBooking/addProposal?appUserId=${
            data?.leadId
          }&companyName=${encodeURIComponent(data?.companyName)}`
        );
      }
      // navigate(`/portals/proposals/convertToProposal?appUserId=${data?.leadId}&companyName=${encodeURIComponent(data?.companyName)}`);
      // navigate("/portals/proposals/addProposal?appUserId=" + data?.leadId);
    } else {
      console.warn("Data ID is undefined");
    }
  };

  // Function to toggle a specific section with explicit sectionName type
  const toggleSection = (sectionName: SectionName) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [sectionName]: !prevState[sectionName], // Toggle the specific section
    }));
  };

  const handleNavigation = () => {
    navigate(-1);
    // navigate("/portals/bookings/viewBooking"); // Navigate to the desired route
  };

  return (
    <div className="h-full py-2 w-full">
      <div className="flex items-center cursor-pointer mb-4">
        <h2
          className="mr-2 text-gray-700 font-semibold text-sm"
          onClick={users}
        >
          Booked
        </h2>
        <img src="/images/arrowIcons.svg" className="mr-2" />
        <span className="text-gray-400 font-semibold text-sm">
          {data?.companyName ? data?.companyName : "NA"}
        </span>
      </div>
      <div
        className="flex gap-2 items-center font-sans pb-7 cursor-pointer"
        onClick={handleNavigation}
      >
        <img src="/images/Back or Arrow left (1).svg" />
        <p className="text-[#2D2E2F] font-bold text-2xl">
          {data?.companyName ? data?.companyName : "NA"}
        </p>
      </div>
      <div className="bg-white w-auto h-auto p-6">
        <div className="flex items-center gap-3 pb-7">
          {/* <img src={data?.profilePic?.documentUrl ? data?.profilePic?.documentUrl :'/images/userImg.svg'} className='rounded-full w-[70px] h-[70px] mr-3' /> */}
          {/* <img
            src="/images/Screenshot (207).png"
            className="rounded rounded-full w-14 h-14"
          /> */}
          <div className="block">
            <div className="flex items-center gap-3">
              <p className="font-bold text-xl">
                {data?.uuid ? data?.uuid : "NA"}
              </p>
              {/* <div className="flex justify-between items-center">
                <span
                  className={`px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusClass(
                    data?.status
                  )}`}
                >
                  <span
                    className="inline-block w-2 h-2 mr-2 rounded-full"
                    style={{ backgroundColor: getDotColor(data?.status) }}
                  ></span>
                 
                  {getBookStatus(data?.leadType)}
                </span>
              </div> */}
              {/* <p>Status</p> */}
            </div>
            <p className="text-[#4B5563] text-base font-normal font-Inter">
              {data?.email ? data?.email : "NA"}
            </p>
          </div>
        </div>
        <p className="border"></p>
        <>
          {/* <p className="border "></p> */}
          <div className="justify-between flex py-5">
            <p className="font-semibold text-xl text-gray-900 pl-5">
              {data?.leadType
                ? leadTypeMappings[data.leadType]
                : data?.proposalType
                ? leadTypeMappings[data.proposalType]
                : "NA"}
            </p>
            {nameOfBooking !== "confirmBooking" && (
              <button
                type="submit"
                className="border rounded-md px-5 py-1 font-bold text-base text-[#374151]"
                onClick={() => editProposal(data)}
              >
                Edit
              </button>
            )}
          </div>
          <div>
            <div className="grid grid-cols-2 pb-5">
              <div className="py-3 pl-5">
                <h2 className="text-gray-700 font-normal text-sm mb-1">
                  Lead Type
                </h2>
                <p className="text-base font-semibold text-gray-900">
                  {data?.leadType ? leadTypeMapping[data?.leadType] : "NA"}
                </p>
              </div>
              <div></div>
              <div className="py-3 pl-5">
                <h2 className="text-gray-700 font-normal text-sm mb-1">
                  {data?.leadType
                    ? getleadType[data.leadType]
                    : data?.proposalType
                    ? getleadType[data.proposalType]
                    : "NA"}
                </h2>
                <p className="text-base font-semibold text-gray-900">
                  {data?.companyName ? data?.companyName : "NA"}
                </p>
              </div>
              <div></div>
              <div className="py-3 pl-5">
                <h2 className="text-gray-700 font-normal text-sm">GstNo</h2>
                <p className="text-base font-semibold text-gray-900">
                  {data?.gstNo ? data?.gstNo : "NA"}
                </p>
              </div>
              <div></div>
              <div className="py-3 pl-5">
                <p className="font-Inter font-normal text-base text-gray-700 mb-1">
                  Website
                </p>
                <p className="font-semibold text-base text-gray-900 ">
                  {data?.website ? data?.website : "NA"}
                </p>
              </div>
              <div></div>
              <div className="py-3 pl-5">
                <p className="font-Inter font-normal text-base text-gray-700 mb-1">
                  Address
                </p>
                <p className="font-semibold text-base text-gray-900 break-words">
                  {[
                    data?.streetAddress,
                    data?.street,
                    data?.apartment,
                    data?.mtCountryDto?.name,
                    data?.state,
                    data?.city,
                    data?.postalCode,
                  ].every((value) => !value?.toString().trim())
                    ? "NA"
                    : [
                        data?.street,
                        data?.streetAddress,
                        data?.apartment,
                        data?.mtCountryDto?.name,
                        data?.city,
                        data?.state,
                        data?.postalCode,
                      ]
                        .filter((value) => value?.toString().trim())
                        .join(", ")}
                </p>
              </div>
              <div></div>
              <div className="py-3 pl-5">
                <p className="font-Inter font-normal text-base text-gray-700 mb-1">
                  Pitched by
                </p>
                <p className="font-semibold text-base text-gray-900">
                  {data?.pitchedBy ? data?.pitchedBy : "NA"}
                </p>
              </div>

              <div></div>
              <div className="py-3 pl-5">
                <p className="font-Inter font-normal text-base text-gray-700 mb-1">
                  Source URL
                </p>
                <p className="font-semibold text-base text-gray-900">
                  {data?.sourceUrl ? data?.sourceUrl : "NA"}
                </p>
              </div>
              <div></div>
              <div className="py-3 pl-5">
                <p className="font-Inter font-normal text-base text-gray-700 mb-1">
                  Source
                </p>
                <p className="font-semibold text-base text-gray-900">
                  {data?.source ? getSource[data.source] : "NA"}{" "}
                </p>
              </div>
            </div>

            <p className="border"></p>
            <div className="">
              <p className="mt-7 font-semibold text-xl text-gray-900 pl-5">
                Personal Details
              </p>
              <div className="grid grid-cols-3 py-5">
                {/* <div className="py-3">
                      <h2 className="text-gray-700 font-normal text-sm">
                        Email
                      </h2>
                      <p className="text-base font-semibold text-gray-900 break-words">
                        {data?.email ? data?.email : "NA"}
                      </p>
                    </div> */}
                <div className="py-3 pl-5">
                  <h2 className="text-gray-700 font-normal text-sm ">
                    Contact Person
                  </h2>
                  <p className="text-base font-semibold text-gray-900 break-words">
                    {data?.contactPerson ? data?.contactPerson : "NA"}
                  </p>
                </div>
                <div className="py-3">
                  <h2 className="text-gray-700 font-normal text-sm">
                    Designation
                  </h2>
                  <p className="text-base font-semibold text-gray-900">
                    {data?.contactPersonRole ? data?.contactPersonRole : "NA"}
                  </p>
                </div>
                <div></div>

                <div className="py-3 pl-5">
                  <h2 className="text-gray-700 font-normal text-sm">
                    Continent
                  </h2>
                  <p className="text-base font-semibold text-gray-900">
                    {data?.mtContinentDto?.name
                      ? data?.mtContinentDto?.name
                      : "NA"}
                  </p>
                </div>
                <div className="py-3">
                  <h2 className="text-gray-700 font-normal text-sm">
                    Company Type
                  </h2>
                  <p className="text-base font-semibold text-gray-900 break-words">
                    {data?.leadType
                      ? leadTypeMapping[data.leadType]
                      : data?.type
                      ? leadTypeMapping[data.type]
                      : data?.proposalType
                      ? leadTypeMapping[data.proposalType]
                      : "NA"}
                  </p>
                </div>
                <div></div>
                <div className="py-3 pl-5">
                  <h2 className="text-gray-700 font-normal text-sm ">
                    Call Back Date
                  </h2>
                  <p className="text-base font-semibold text-gray-900">
                    {data?.callBackDate ? data?.callBackDate : "NA"}
                  </p>
                </div>
                <div className="py-3">
                  <h2 className="text-gray-700 font-normal text-sm">
                    Contact Number
                  </h2>
                  <p className="text-base font-semibold text-gray-900 break-words">
                    {data?.contactNo ? data?.contactNo : "NA"}
                  </p>
                </div>
                <div></div>
                <div className="py-3 pl-5">
                  <h2 className="text-gray-700 font-normal text-sm break-words">
                    Direct Number
                  </h2>
                  <p className="text-base font-semibold text-gray-900">
                    {data?.directNo ? data?.directNo : "NA"}
                  </p>
                </div>
                <div className="py-3 ">
                  <h2 className="text-gray-700 font-normal text-sm">Country</h2>
                  <p className="text-base font-semibold text-gray-900">
                    {data?.leadRespDto?.mtCountryDto?.name
                      ? data?.leadRespDto.mtCountryDto.name
                      : data?.mtCountryDto?.name
                      ? data?.mtCountryDto?.name
                      : "NA"}
                  </p>
                </div>
                <div></div>

                <div className="py-3 pl-5">
                  <h2 className="text-gray-700 font-normal text-sm">
                    Feedback
                  </h2>
                  <p className="text-base font-semibold text-gray-900 break-words">
                    {data?.feedback ? data?.feedback : "NA"}
                  </p>
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <p className="border border-gray-200"></p>

          {data?.leadRespDto?.eventRespDtos?.length > 0 && (
            <div className="py-5 w-full">
              <h1 className="text-xl font-semibold text-gray-900 mb-5">
                Events
              </h1>
              {data?.leadRespDto?.eventRespDtos?.map(
                (event: EventReqDtos, index: number) => (
                  <div
                    className="eventCard flex gap-5 p-5 w-full mb-5 bg-gray-100"
                    key={event.id}
                  >
                    <div className="w-1/5">
                      <div className="w-full h-32">
                        <img
                          src={
                            event?.imageDto?.documentUrl
                              ? event?.imageDto?.documentUrl
                              : "/images/eventImage-1.svg"
                          }
                          alt="eventImage-1"
                          className={`w-full ${
                            event?.imageDto?.documentUrl
                              ? "h-full object-cover"
                              : "h-auto"
                          }`}
                        />
                      </div>
                    </div>
                    <div>
                      <div className="grid grid-cols-4">
                        <div className="pb-2">
                          <h4 className="text-sm text-gray-900">Event Name</h4>
                          <h1 className="text-lg font-semibold text-gray-900 break-all">
                            {event?.name ? event?.name : "NA"}
                          </h1>
                        </div>
                        <div className="pb-2">
                          <h4 className="text-sm text-gray-900 ">
                            Contact Person Name
                          </h4>
                          <h1 className="text-lg font-semibold text-gray-900 break-all">
                            {event?.contactPersonName
                              ? event?.contactPersonName
                              : "NA"}
                          </h1>
                        </div>
                        <div></div>
                        <div></div>
                        <div className="pb-2">
                          <h4 className="text-sm text-gray-900">Event Type</h4>
                          <h1 className="text-lg font-semibold text-gray-900">
                            {getEventTypes(event?.type)}
                          </h1>
                        </div>
                        <div className="pb-2">
                          <h4 className="text-sm text-gray-900 ">
                            Contact Person Email
                          </h4>
                          <h1 className="text-lg font-semibold text-gray-900 break-words">
                            {event?.contactPersonEmail
                              ? event?.contactPersonEmail
                              : "NA"}
                          </h1>
                        </div>
                        <div></div>
                        <div></div>
                        <div className="pb-2">
                          <h4 className="text-sm text-gray-900">
                            Event Country
                          </h4>
                          <h1 className="text-lg font-semibold text-gray-900">
                            {event?.mtCountryDto?.name
                              ? event?.mtCountryDto?.name
                              : "NA"}
                          </h1>
                        </div>
                        <div className="pb-2">
                          <h4 className="text-sm text-gray-900 ">
                            Phone Number
                          </h4>
                          <h1 className="text-lg font-semibold text-gray-900">
                            {event?.phoneNo ? event?.phoneNo : "NA"}
                          </h1>
                        </div>
                        <div></div>
                        <div></div>
                      </div>

                      <p className="font-semibold text-[#B00A2B] pb-2 break-all">
                        Event Link - {event?.link ? event?.link : "NA"}
                      </p>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-2">
                          <img
                            src="/images/dateIcon.svg"
                            alt="dateicon"
                            className="size-4"
                          />
                          <p className="text-gray-600 w-[204px]">
                            {event?.startDate ? event?.startDate : "NA"} to{" "}
                            {event?.endDate ? event?.endDate : "NA"}
                          </p>
                        </div>
                        <div className="flex items-center gap-2">
                          <img
                            src="/images/locationMark.svg"
                            alt="locationMark Icon"
                            className="size-4"
                          />
                          <p className="text-gray-600 break-all">
                            {event?.venue}
                          </p>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-4">
                        {event?.eventDetails && (
                          <div>
                            <h2 className="text-gray-700 font-normal text-sm">
                              Event Details
                            </h2>

                            <p className="font-semibold text-base text-gray-900 pt-1 break-words">
                              <ReadMore
                                text={event?.eventDetails || "NA"}
                                lines={10}
                              />
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          )}

          {data?.leadRespDto?.centerRespDtos?.length > 0 && (
            <div className="py-5 w-full">
              <h1 className="text-xl font-semibold text-gray-900 mb-5">
                Center Details
              </h1>
              {data?.leadRespDto?.centerRespDtos?.map(
                (event: HospitalCenterReqDto, index: number) => (
                  <div
                    className="eventCard flex gap-[27px] p-5 w-full mb-5 bg-gray-100"
                    key={event.id}
                  >
                    <div className="w-1/5">
                      <div className="w-full h-28">
                        <img
                          src={
                            event?.imageDto?.documentUrl
                              ? event?.imageDto?.documentUrl
                              : "/images/eventImage-1.svg"
                          }
                          alt="eventImage-1"
                          className={`w-full ${
                            event?.imageDto?.documentUrl
                              ? "h-full object-cover"
                              : "h-full"
                          }`}
                        />
                      </div>
                    </div>
                    <div className="w-4/5 flex flex-col gap-3 font-Inter">
                      <h1 className="text-lg text-gray-900">
                        {/* <span className='font-normal text-sm'>Branch Address</span>  */}
                        <span className="text-lg font-semibold text-gray-900">
                          {event?.branchAddress || "NA"}
                        </span>
                      </h1>

                      <div className="grid grid-cols-3 font-sans">
                        <div>
                          <p className="font-normal text-sm text-gray-600">
                            Specialization
                          </p>
                          <p className="font-semibold text-base text-gray-600">
                            {event?.specialization || "NA"}
                          </p>
                        </div>
                        <div>
                          <h4 className="text-sm text-gray-600">Center Size</h4>
                          <h1 className="font-semibold text-gray-600 text-base">
                            {event?.centerSize
                              ? getCenterSize[event?.centerSize]
                              : "Small"}
                          </h1>
                        </div>
                      </div>

                      {/* <p className='font-semibold text-[#B00A2B]'>Event Link - {event?.link}</p> */}
                    </div>
                  </div>
                )
              )}
            </div>
          )}
        </>
        <div className="font-Inter">
          <div className="justify-between flex pt-7">
            {(data?.isCompanyProfiling ||
              data?.isEventProfiling ||
              data?.isHospitalProfiling ||
              data?.isBannerAds ||
              data?.isCenterListing ||
              data?.isContentMarketing ||
              data?.isEmailMarketing ||
              data?.isNewsLetterAds ||
              data?.isPrintAd ||
              data?.isEventListing) && (
              <p className="font-semibold text-xl">Service Details</p>
            )}
            {/* <div
              className="border border-gray-300 py-1 px-5 text-[#374151] font-bold text-base rounded-[8px] cursor-pointer"
              onClick={() => editProfile(data)}
            >
              Edit
            </div> */}
          </div>
          <div>
            {data?.proposalType !== "COMPANY" &&
              data?.leadType !== "COMPANY" &&
              (data?.isEventProfiling || data?.isHospitalProfiling) && (
                <div className="bg-[#FFF2F5] rounded-md mb-5">
                  <p className="text-base font-semibold px-4 py-3">
                    {data?.proposalType === "EVENT_ORGANIZER" ||
                    data?.leadType === "EVENT_ORGANIZER"
                      ? "Event Organiser Profiling"
                      : "Hospital Profiling"}
                  </p>
                </div>
              )}
            {(data?.proposalType === "COMPANY" ||
              data?.leadType === "COMPANY") &&
              data?.isCompanyProfiling && (
                <div className="bg-[#FFF2F5] rounded-md mb-5">
                  <p className="text-base font-semibold px-4 py-3">
                    Company Profiling
                  </p>
                </div>
              )}

            <div className="mb-5">
              {data?.isBannerAds && (
                <div
                  className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer"
                  onClick={() => toggleSection("bannerAds")}
                >
                  <p className="text-base font-semibold px-4 py-3">
                    Banner ads
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.bannerAds
                          ? "rotate-[180deg]"
                          : "rotate-[0deg]"
                      }`}
                      src="/images/rightIcon.svg"
                    />
                  </span>
                </div>
              )}
              {openSections.bannerAds && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="flex gap-10 mb-5">
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          Start date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {data?.bannerAdFrom ? data?.bannerAdFrom : "NA"}
                        </p>
                      </div>
                      <p className="border"></p>
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          End date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {data?.bannerAdTo ? data?.bannerAdTo : "NA"}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Banners
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {data?.noOfBanners ? data?.noOfBanners : "NA"}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="mb-5">
              {data?.isEventListing && (
                <div
                  className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer"
                  onClick={() => toggleSection("isEventListing")}
                >
                  <p className="text-base font-semibold px-4 py-3">
                    Event Listing
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.isEventListing
                          ? "rotate-[180deg]"
                          : "rotate-[0deg]"
                      }`}
                      src="/images/rightIcon.svg"
                    />
                  </span>
                </div>
              )}
              {openSections[`isEventListing`] && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Events
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {data?.noOfEvents ? data?.noOfEvents : "NA"}
                      </p>
                    </div>
                    <div className="flex gap-10 mb-10">
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          Start date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {data?.eventListingFrom
                            ? data?.eventListingFrom
                            : "NA"}
                        </p>
                      </div>
                      <p className="border"></p>
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          End date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {data?.eventListingTo ? data?.eventListingTo : "NA"}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="mb-5">
              {data?.isEmailMarketing && (
                <div
                  className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer"
                  onClick={() => toggleSection("emailMarketing")}
                >
                  <p className="text-base font-semibold px-4 py-3">
                    Email Marketing
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.emailMarketing
                          ? "rotate-[180deg]"
                          : "rotate-[0deg]"
                      }`}
                      src="/images/rightIcon.svg"
                    />
                  </span>
                </div>
              )}
              {openSections.emailMarketing && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Counts
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {data?.noOfRecipients ? data?.noOfRecipients : "NA"}
                      </p>
                    </div>
                    <div>
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of EDMs
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {data?.noOfEdms ? data?.noOfEdms : "NA"}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="mb-5">
              {data?.isNewsLetterAds && (
                <div
                  className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer"
                  onClick={() => toggleSection("eNewsLetter")}
                >
                  <p className="text-base font-semibold px-4 py-3">
                    Ads in e-newsletter
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.eNewsLetter
                          ? "rotate-[180deg]"
                          : "rotate-[0deg]"
                      }`}
                      src="/images/rightIcon.svg"
                    />
                  </span>
                </div>
              )}

              {openSections.eNewsLetter && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="flex gap-10 mb-5">
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          Start date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {data?.newsLetterAdFrom
                            ? data?.newsLetterAdFrom
                            : "NA"}
                        </p>
                      </div>
                      <p className="border"></p>
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          End date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {data?.newsLetterAdTo ? data?.newsLetterAdTo : "NA"}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of e-newsletter
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {data?.noOfNewsBanners ? data?.noOfNewsBanners : "NA"}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="mb-5">
              {data?.isContentMarketing && (
                <div
                  className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer"
                  onClick={() => toggleSection("contentMarketing")}
                >
                  <p className="text-base font-semibold px-4 py-3">
                    Content Marketing
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.contentMarketing
                          ? "rotate-[180deg]"
                          : "rotate-[0deg]"
                      }`}
                      src="/images/rightIcon.svg"
                    />
                  </span>
                </div>
              )}
              {openSections.contentMarketing && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Posts
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {data?.noOfPosts ? data?.noOfPosts : "NA"}
                      </p>
                    </div>
                    <div className="flex gap-10 mb-10">
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          Start date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {data?.contntMarktAdFrom
                            ? data?.contntMarktAdFrom
                            : "NA"}
                        </p>
                      </div>
                      <p className="border"></p>
                      <div>
                        <p className="text-[#6D6D6D] font-semibold text-sm">
                          End date
                        </p>
                        <p className="text-[#374151] font-semibold text-sm">
                          {data?.contntMarktAdTo ? data?.contntMarktAdTo : "NA"}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="mb-5">
              {data?.isPrintAd && (
                <div
                  className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer"
                  onClick={() => toggleSection("printAdvertisement")}
                >
                  <p className="text-base font-semibold px-4 py-3">
                    Print Advertisement
                  </p>
                  <span>
                    <img
                      className={`size-6 w-14 h-8 ${
                        openSections.printAdvertisement
                          ? "rotate-[180deg]"
                          : "rotate-[0deg]"
                      }`}
                      src="/images/rightIcon.svg"
                    />
                  </span>
                </div>
              )}
              {openSections.printAdvertisement && (
                <>
                  <p className="border"></p>
                  <div className="bg-[#F6F6F6] p-4 mb-5">
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Advertisements
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {data?.printAdd ? data?.printAdd : "NA"}
                      </p>
                    </div>
                    <div className="mb-5">
                      <p className="text-[#6D6D6D] font-semibold text-sm">
                        Number of Issues
                      </p>
                      <p className="text-[#374151] text-base font-semibold ">
                        {data?.noOfPrintAds ? data?.noOfPrintAds : "NA"}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
            {data?.proposalType !== "EVENT_ORGANIZER" &&
              data?.leadType !== "EVENT_ORGANIZER" && (
                <>
                  {data?.additionalService && (
                    <div
                      className="bg-[#FFF2F5] flex items-center justify-between cursor-pointer"
                      onClick={() => toggleSection("additionalService")}
                    >
                      <p className="text-base font-semibold px-4 py-3">
                        Additional Services
                      </p>
                      <span>
                        <img
                          className={`size-6 w-14 h-8 ${
                            openSections.additionalService
                              ? "rotate-[180deg]"
                              : "rotate-[0deg]"
                          }`}
                          src="/images/rightIcon.svg"
                        />
                      </span>
                    </div>
                  )}
                  {openSections.additionalService && (
                    <>
                      <p className="border"></p>
                      <div className="bg-[#F6F6F6] p-4 mb-5">
                        <div className="mb-5">
                          <p className="text-[#6D6D6D] font-semibold text-sm">
                            Additional Services
                          </p>
                          <p className="text-[#374151] text-base font-semibold ">
                            {data?.additionalService
                              ? data?.additionalService
                              : "NA"}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;
